
import { Component, Prop, Vue, Provide } from 'vue-property-decorator';
import moment from 'moment';
moment.locale('zh-cn');
import changeAirport from '../assets/js/airport/changeAirport';

@Component({
    filters: {
        Date(data: any) {
            return moment(data).format('MM-DD HH:mm');
        },
        City(data: any) {
            return changeAirport.changeAirportCode(data).cityCName || '无';
        },
        AirPort(data: string) {
            return changeAirport.changeAirportCode(data).airportCName || '无';
        },
        AirLine(data: string) {
            return data.length >= 2 ? changeAirport.changeAirCompany(data.substr(0, 2)) + data : '获取失败';
        },
    },

})
export default class AirPortTicket extends Vue {
  @Prop() private airport: any;
  
  // 改签
  private changeAirport() {
    localStorage.setItem('AirTicketTrip', JSON.stringify(this.airport));
    localStorage.setItem('CurrentTripInfo', JSON.stringify(this.airport));
    localStorage.setItem('AirTicketFor', 'changeAir');
    this.$router.push('/airticket-booking');
  }
  // 退票
  private refundAirport() {
    localStorage.setItem('tripInfo', JSON.stringify(this.airport));
    this.$router.push('/airticket-refund');
  }
}
